```vue
<template>
  <div class="card mb-25 border-0 rounded-0 bg-white add-user-card">
    <div class="card-body p-15">
      <Form ref="propositionForm" @submit="addProposition" :validation-schema="propositionSchema">
        <div class="row">
          <div class="col-md-4">
            <div class="form-group mb-10">
              <label class="d-block text-black fw-semibold mb-10">
                Contenu <span class="text-danger">*</span>
              </label>
              <Field
                name="contenu"
                type="text"
                class="form-control shadow-none text-black"
                placeholder="Entrer le contenu"
                v-model="formData.contenu"
              />
              <ErrorMessage name="contenu" class="text-danger" />
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group mb-10">
              <label class="d-block text-black fw-semibold mb-10">
                Est la bonne réponse <span class="text-danger">*</span>
              </label>
              <Field name="estLaBonneReponse" v-slot="{ field }">
                <Multiselect
                  :options="booleanOptions"
                  :searchable="true"
                  track-by="label"
                  label="label"
                  v-model="formData.estLaBonneReponse"
                  v-bind="field"
                  placeholder="Sélectionner une option"
                />
              </Field>
              <ErrorMessage name="estLaBonneReponse" class="text-danger" />
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group mb-10">
              <label class="d-block text-black fw-semibold mb-10">
                Question <span class="text-danger">*</span>
              </label>
              <Field name="questionId" v-slot="{ field }">
                <Multiselect
                  :options="questionOptions"
                  :searchable="true"
                  track-by="label"
                  label="label"
                  v-model="formData.questionId"
                  v-bind="field"
                  placeholder="Sélectionner une question"
                />
              </Field>
              <ErrorMessage name="questionId" class="text-danger" />
            </div>
          </div>
          <div class="col-md-12 mt-5">
            <div class="d-flex align-items-center">
              <button
                class="btn btn-success me-3"
                type="submit"
                :disabled="isDisable"
                :class="{ 'cursor-not-allowed': isDisable }"
              >
                Ajouter une proposition
              </button>
              <router-link
                to="/liste-propositions"
                class="btn btn-danger"
              >
                <i class="fa fa-trash-o lh-1 me-1 position-relative top-2"></i>
                Annuler
              </router-link>
            </div>
          </div>
        </div>
      </Form>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, reactive, computed, onMounted } from 'vue';
import { Form, Field, ErrorMessage } from 'vee-validate';
import * as Yup from 'yup';
import ApiService from '@/services/ApiService';
import { success, error } from '@/utils/utils';
import Multiselect from '@vueform/multiselect';
import { useRouter } from 'vue-router';

export default defineComponent({
  name: 'AddPropositionSondage',
  components: {
    Form,
    Field,
    ErrorMessage,
    Multiselect,
  },
  setup() {
    const router = useRouter();
    const propositionForm = ref<InstanceType<typeof Form> | null>(null);

    const formData = reactive({
      contenu: '',
      estLaBonneReponse: '',
      questionId: '',
    });

    const propositionSchema = Yup.object().shape({
      contenu: Yup.string().required('Le contenu est obligatoire'),
      estLaBonneReponse: Yup.string().required('La bonne réponse est obligatoire'),
      questionId: Yup.string().required('La question est obligatoire'),
    });

    const booleanOptions = ref([
      { value: 'true', label: 'Oui' },
      { value: 'false', label: 'Non' },
    ]);

    const questionOptions = ref([]);

    const validateField = (value: string) => {
      return !value || value.trim() === '';
    };

    const isDisable = computed(() => {
      return !formData.contenu || !formData.estLaBonneReponse || !formData.questionId;
    });

    const loadQuestions = async () => {
      try {
        const { data } = await ApiService.get('/questions');
        questionOptions.value = data.data.data.map((question: any) => ({
          value: question.id,
          label: question.contenu,
        }));
      } catch (err: any) {
        const message = err.response?.data?.message || 'Erreur lors du chargement des questions';
        console.error('Erreur loadQuestions:', err);
        error(message);
      }
    };

    const addProposition = async (values: any, { resetForm }: any) => {
      const propositionData = {
        contenu: formData.contenu,
        estLaBonneReponse: formData.estLaBonneReponse === 'true',
        questionId: formData.questionId,
      };

      console.log('Données envoyées:', propositionData);

      try {
        const { data } = await ApiService.post('/propositions', propositionData);
        if (data.code === 201) {
          success(data.message);
          resetForm();
          formData.contenu = '';
          formData.estLaBonneReponse = '';
          formData.questionId = '';
          router.push({ name: 'ListePropositionPage' });
        }
      } catch (err: any) {
        const message = err.response?.data?.message || 'Erreur lors de la création de la proposition';
        console.error('Erreur addProposition:', err);
        error(message);
      }
    };

    onMounted(() => {
      console.log('Composant monté - Chargement des questions');
      loadQuestions();
    });

    return {
      propositionSchema,
      propositionForm,
      formData,
      booleanOptions,
      questionOptions,
      validateField,
      isDisable,
      addProposition,
    };
  },
});
</script>

<style scoped>
.cursor-not-allowed {
  cursor: not-allowed;
}
.marge-droite {
  margin-left: 87px;
}
.hr-longueur {
  width: 80%;
}
.bord1 {
  border: 1px solid #07a;
}
.fond {
  background-color: rgb(94, 191, 233);
}
</style>
```